const state = {
  getlist: 'state/getlist',
  add: 'state/add',
  update: 'state/update',
  remove: 'state/remove',
  get: 'state/get',
  getall: 'state/getall',
}
export default state
